import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { selectProperty, selectLoading, selectOriginalFavorites, getProperty, saveProperty } from 'data/property';
import Confirm from 'app/components/Confirm';
import AddToGroup from 'app/components/AddToGroup';
import AddToMarketingListModal from 'app/components/AddToMarketingListModal';
import { getAppendJobEstimate, selectAppendGroups } from '../../data/contacts';
import SkipTraceModal from './SkipTraceModal';
import { searchPropertyContactsByPropertyID,getPropertyContact } from '../../data/property/actions';
import { selectUsageSection, selectProfile, selectPlanDetails } from '../../data/user';
import LeaveMessagePopup from '../AccountNew/modals/LeaveMessage';
import ActivateSubscriptionPopup from '../AccountNew/modals/ActivateSubscription';
import PurchaseSavesAndExportsPopup from '../AccountNew/modals/PurchaseSavesAndExports';
import InfoAlert from './InfoAlert';


export default function (ComposedComponent, mapStatetoProps, actionCreators) {
  class Container extends React.PureComponent {
    constructor(props) {
      super(props);

      this.saveProperty = this.saveProperty.bind(this);
      this.loadProperty = this.loadProperty.bind(this);
      this.checkSavedProperty = this.checkSavedProperty.bind(this);
      this.loadPropertyAfterSave = this.loadPropertyAfterSave.bind(this);
    }

    // `onSaved` is the property AI chat's own callback; this method doesn't call `onComplete`
    // (as before), so checkSavedProperty callers are unchanged. It's called with
    // `{ skipTraceStarted: true }` once the "Skip Trace This Property" checkbox has started the
    // trace, `{ skipTraceFinished: true }` once its contact has been reloaded,
    // `{ skipTraceFailed: status }` when that trace didn't complete (status from the Skip Trace API,
    // 'ERROR' if it couldn't start, 'RELOAD_ERROR' if its contact couldn't be reloaded), or
    // `{ skipTraceStarted: false }` once a plain save has reloaded the contact. Nothing is
    // called if a skip trace is already in progress.
    saveProperty(onComplete, propertyId = this.props.propertyId, isRedactedContact = false, onSaved) {
      const { saveProperty, openAddToMarketingListModal, favorites, getAppendJobEstimate, SkipTraceModal, searchPropertyContactsByPropertyID, appendGroups, usageSectionDetails,openInfoAlert, leaveMessagePopup} = this.props;
      // openAddToGroup({
      //   selectLoading,
      //   groups: favorites,
      //   size: 1,
      //   addPropertyMode: true,
      //   onComplete,
      //    groupType: 'Marketing List',
      //   save: onComplete => saveProperty(propertyId, null, ({ response: { quantity } }) => onComplete(quantity)),
      //   add: (name, onComplete) => saveProperty(propertyId, { name }, ({ response: { quantity } }) => onComplete(quantity)),
      // });

      const { overdueAccount } = this.props.profile;
      const { planDetails } = this.props;
      if(overdueAccount){
        const currentPlan  =  planDetails && planDetails.accountEnrolledPlans && planDetails.accountEnrolledPlans.find(plan => plan.active);
        const total = currentPlan ? currentPlan.quantity : 0;
        this.props.leaveMessagePopup({
            title: "Subscription Past Due",
            message: `Your subscription is past due, and no new properties can be saved. Upgrade now to access the full ${total}.`,
            yesLable: "Upgrade",
            cancelLable: "Cancel",
            yesRedirect: () => {
              // Open the Activate Subscription popup
              this.props.openAccountUpgrade();
            },
          })
      }
      else if (usageSectionDetails?.id && usageSectionDetails?.savesRemaining <= 0 ) {
        leaveMessagePopup({
          title: "Not Enough Save Credits",
          message:
            "You don’t have enough save credits to perform this action. Please purchase additional credits to continue.",
          yesLable: "Purchase Credits",
          cancelLable: "Cancel",
          yesRedirect: () => {
            // Open the Activate Subscription popup
            this.props.purchaseSavesAndExportsPopup();
          },
        })
      } else {
        openAddToMarketingListModal({
          title: 'Add to Group',
          checkboxLabel: "Skip Trace This Property",
          groups: favorites,
          hideSkipTraceOption: isRedactedContact,
          // The modal's own completion callback; named so it doesn't shadow saveProperty's `onComplete`.
          onSave: (name, onModalComplete, { skipTrace, isCreated }) => {

            const afterSave = ({ response: { quantity, groups } }) => {

              const groupId = groups?.find(
                g => g.name === name
              )?.id;

              if (!skipTrace) {
                onModalComplete(quantity);
                // Tell the chat only once the contact is reloaded, so a skip trace it starts has the contact id.
                this.loadPropertyAfterSave(
                  propertyId,
                  () => onSaved?.({ skipTraceStarted: false }),
                  // Without the contact the chat can't start its skip trace
                  () => onSaved?.({ skipTraceFailed: 'ERROR' })
                );
                return;
              }

              const payload = {
                id: groupId,
                allSelected: false,
                remainingSelected: false,
                selectedIds: [propertyId],
                unselectedIds: [],
                recentContactsOnly: !isCreated,
                selected: 1,
                filters: [],
                sortModel: [],
              };

              const mode = "BOTH";
              const reprocessEnabled = false;
              searchPropertyContactsByPropertyID(payload, ({ response: contactIds }) => {
                getAppendJobEstimate({
                  contactIds,
                  appendMode: mode,
                  reprocessEnabled
                }, ({ response, error }) => {
                  // Keep the "Add to Group" modal open (its Save button already shows a
                  // loading spinner while savePropertyLoading/contactLoading are true) until
                  // right before the next popup appears, so there's no window with neither
                  // modal on screen where the user could click something behind them.
                  onModalComplete(quantity);

                  if (response?.message && response?.message?.includes("There is an existing append job")) {
                    openInfoAlert({
                      title: "Skip Trace in Progress",
                      infoText: "There is a Skip Trace currently in progress. Please try again once it is complete.",
                    });
                  } else {
                    SkipTraceModal({
                      groups: appendGroups,
                      reprocessEnabled: false,
                      contactIds,
                      selectedProperties: 1,
                      isPropertySkipTrace: true,
                      onSuccess: () => {
                        // The checkbox started the trace, so the chat must not start a second one.
                        onSaved?.({ skipTraceStarted: true });
                        this.loadPropertyAfterSave(
                          propertyId,
                          () => onSaved?.({ skipTraceFinished: true }),
                          () => onSaved?.({ skipTraceFailed: 'RELOAD_ERROR' })
                        );
                      },
                      // The checkbox's trace didn't complete: still reload the property (SAVE_PROPERTY_SUCCESS
                      // keeps the pre-save contact, and a duplicate returns cached data), then the chat shows
                      // why and doesn't start another.
                      onFailure: (status) => this.loadPropertyAfterSave(
                        propertyId,
                        () => onSaved?.({ skipTraceFailed: status }),
                        () => onSaved?.({ skipTraceFailed: status === 'DUPLICATE' ? 'RELOAD_ERROR' : status })
                      ),
                    });
                  }
                }, () => {
                  // Estimate failed: close the "Add to Group" modal and tell the chat the trace didn't start
                  onModalComplete(quantity);
                  onSaved?.({ skipTraceFailed: 'ERROR' });
                });
              })

            };

            saveProperty(propertyId, { name }, afterSave)
          },
        });
      }
    }

    loadPropertyAfterSave(id, afterLoad = () => {}, afterError = () => {}){
      const { getPropertyContact } = this.props;
      getPropertyContact(id, afterLoad, afterError);
    }

    loadProperty(id) {
      const { getProperty, propertyId,getPropertyContact } = this.props;
      if (id !== propertyId) {
        getProperty(id, 'F');
        if (typeof this.props.getPropertyContact === 'function') {
            getPropertyContact(id, () => {});
        }
      }
      
    }

    checkSavedProperty(callback) {
      const { savedPropertyId, confirm } = this.props;
      if (savedPropertyId) callback(savedPropertyId);
      else {
        confirm({
          question: 'This action can only be performed on Saved Properties. Would you like to save this property?',
          textAlign: Confirm.textAlign.center,
          onOk: () => this.saveProperty(callback),
        });
      }
    }

    render() {
      return (
        <ComposedComponent
          {...this.props}
          {...this.boundActionCreators}
          saveProperty={this.saveProperty}
          loadProperty={this.loadProperty}
          checkSavedProperty={this.checkSavedProperty}
        />
      );
    }
  }

  Container.propTypes = { dispatch: PropTypes.func };
  Container.defaultProps = { dispatch: () => {} };

  return connect((state, props) => {
    const property = selectProperty(state);
    const savedPropertyId = property.get('savedPropertyId');

    return {
      ...mapStatetoProps(state, props),
      property,
      savedPropertyId,

      propertyId: property.get('id'),
      propertySaved: !!savedPropertyId,
      loading: selectLoading(state),
      favorites: selectOriginalFavorites(state).filter(g => g.get('name') !== 'All Saved Properties'),
      appendGroups: selectAppendGroups(state),
      usageSectionDetails : selectUsageSection(state),
      profile: selectProfile(state)?.toJS(),
      planDetails: selectPlanDetails(state)?.toJS(),
    };
  }, {
    ...actionCreators,
    saveProperty,
    getProperty,
    getPropertyContact,
    getAppendJobEstimate,
    searchPropertyContactsByPropertyID,
    confirm: Confirm.open,
    openAddToGroup: AddToGroup.open,
    SkipTraceModal: SkipTraceModal.open,
    openAddToMarketingListModal:AddToMarketingListModal.open,
    leaveMessagePopup: LeaveMessagePopup.open,
    openAccountUpgrade: ActivateSubscriptionPopup.open,
    purchaseSavesAndExportsPopup: PurchaseSavesAndExportsPopup.open,
    openInfoAlert: InfoAlert.open,
  })(Container);
}
